import React from 'react';
import GuidesData from './GuidesData';
import GuidesCatalogue from './GuidesCatalogue';

//const apiUrl = 'https://run.mocky.io/v3/6d72df2d-e13b-430e-89b9-66826419d65c'; 
const apiUrl = 'https://run.mocky.io/v3/6d72df2d-e13b-430e-89b9-66826419d65c';

const GuidesPage = ({guides}) => {
 

  return (
    <div>
      {guides.length > 0 ? (
        <GuidesCatalogue guides={guides} />
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default GuidesPage;
